import React, { useState } from "react";

type Props = {
  title: any;
  icon?: any;
  desc?: string;
  classname?: string;
  whiteIcon?: any;
};

export default function SectionCardMobile({
  title,
  icon,
  desc,
  classname,
  whiteIcon,
}: Props) {
  const [enter, setEnter] = useState(false);
  const MouseEnter = () => {
    setEnter(true);
  };
  const MouseLeave = () => {
    setEnter(false);
  };
  const textsize = enter
    ? "d-flex text-white font-16 fonts-800 line-19 pt-10 justify-content-center align-items-center"
    : "d-flex dark-header font-24 fonts-800 line-28 pt-1 justify-content-center align-items-center";
  const imgsize = enter ? "w-40 mt-30" : "w-50 mt-30";
  return (
    <>
      <div
        className={`${classname} card-border landing-cards text-center`}
        onMouseEnter={MouseEnter}
        onMouseLeave={MouseLeave}
        onTouchStart={MouseEnter}
        onTouchEnd={MouseLeave}
      >
        <img
          className={`${imgsize} pb-10`}
          src={enter ? whiteIcon : icon}
          alt={icon}
        />

        <p
          className={`${textsize} font-family-roboto-flex pb-10 text-center px-35`}
        >
          {title}
        </p>
        {desc && (
          <p className="text-white font-13 px-10 font-family-roboto fonts-400 line-15">
            {enter ? desc : ""}
          </p>
        )}
      </div>
    </>
  );
}
